import React from 'react'
import '../../App.css';
import TechHeroSection from '../TechHeroSection';
import TechSection from '../TechSection';

function Technology() {
  return (
    <>
    <TechHeroSection/>
    <TechSection/>
    </>
  )
}

export default Technology
